import {IUser, IUserRegisterRequest} from "@plumeuk/shapeshift-types"

export interface IAuthContext {
    logout: () => void,
	login: (username: string, password: string) => Promise<ILoginResponse>,
	jwt?: string,
	user?: IUser,
	authenticated: boolean,
	config?: IAuthContextConfig,
	changePassword: (currentPassword: string, password: string, passwordConfirmation: string) => Promise<ILoginResponse>,
	registerUser: (request: IUserRegisterRequest, additionalPayload?: Object) => Promise<ILoginResponse>,
	resetPassword: (code: string, password: string, passwordConfirmation: string) => Promise<void>,
	forgottenPassword: (email: string) => Promise<void>,
	setUser: React.Dispatch<React.SetStateAction<IUser | undefined>>
}

export interface ILoginRequest {
	identifier: string,
	password: string
}

export const TLoginRequest: ILoginRequest = {
	identifier: "",
	password: ""
}

export const TForgottenPasswordRequest: IForgetPasswordRequest = {
	email: ""
}

export const TResetPasswordRequest: IResetPasswordRequest = {
	password: "",
	passwordConfirmation: "",
	code: "	"
}

export interface ILoginResponse {
	jwt: string,
	user: IUser
}

export interface IForgetPasswordRequest {
	email: string
}

export interface IResetPasswordRequest {
	password: string,
	passwordConfirmation: string
	code: string
}

export interface IAuthContextConfig {
	baseApiUrl: string
}

export interface IChangePasswordRequest {
	currentPassword: string,
	password: string,
	passwordConfirmation: string,
}